import React from 'react';

interface IProps {
  id?: string;
  className?: string;
  children;
}

export const MaxWidthContainer: React.FC<IProps> = ({ id, className, children }) => (
  <div id={id} className={`mx-auto w-full md:w-[768px] lg:w-[1032px] ${className}`}>
    {children}
  </div>
);
